<div
  class="empty-state-screen"
  [ngClass]="{
    'empty-state-screen--bg-gradient': gradientBd(),
  }"
>
  <div class="empty-state-screen__icon">
    @if (icon(); as iconName) {
      <fr8bot-ui-icon [name]="iconName" [size]="50" />
    }
  </div>

  <div class="empty-state-screen__title">
    {{ title() }}
  </div>

  <div class="empty-state-screen__description">
    {{ description() }}
  </div>

  <div class="empty-state-screen__buttonWrapper">
    <ng-content select="[oneButton]"></ng-content>
  </div>
</div>
